import type { FeatureRoutes } from '@/app/screens'

/*
 * The platform console: its own login and layout, no org session (standalone).
 * One page per area of its sidebar; an unknown address leads to its overview.
 */
export default {
  routes: [
    {
      path: '/platform', component: () => import('./PlatformApp.vue'), meta: { standalone: true },
      children: [
        { path: '', component: () => import('./PlatformOverview.vue') },
        { path: 'companies', component: () => import('./CompaniesPage.vue') },
        { path: 'companies/:id', component: () => import('./CompanyPage.vue'), props: true },
        { path: 'new-company', component: () => import('./NewCompanyPage.vue') },
        { path: 'servers', component: () => import('./ServersPage.vue') },
        { path: 'gsm', component: () => import('./GsmGatewaysPage.vue') },
        { path: 'billing', component: () => import('./BillingPage.vue') },
        { path: 'ai', component: () => import('./AiPage.vue') },
        { path: 'mail', component: () => import('./MailPage.vue') },
        { path: 'services', component: () => import('./ServicesPage.vue') },
        { path: 'admins', component: () => import('./AdminsPage.vue') },
        { path: 'journal', component: () => import('./JournalPage.vue') },
        { path: ':rest(.*)+', redirect: '/platform' },
      ],
    },
  ],
} satisfies FeatureRoutes
